var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"32","height":"32","viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}},_vm._l((_vm.dots),function(dot){return _c('rect',{key:dot.dotId,staticClass:"dot",class:dot.color,attrs:{"x":dot.x,"y":dot.y,"width":"4","height":"4"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }